import React from "react";
import Header from "../components/Header";
import FooterSection from "../components/FooterSection";
import Search from "../components/Search";


const SearchPage = () => {
    return (
        <div>
            <Header />
            <Search />
            <FooterSection />
        </div>
    );
};

export default SearchPage;
